export default __webpack_public_path__ + "static/media/e-email.b8c7d823.svg";